import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import * as Yup from "yup";

import {selectAllKits, selectAllSamples} from "../../../../slices/SampleFunctionalSlice";
import {selectCurrentKitId, selectCurrentSampleId} from "../../../../slices/SampleSlice/selectors";
import {getCurrentUser} from "../../../../slices/UserSlice";
import {TYPE_FORMS} from "../../../SamplesList/SamplesList";
import {formSampleValues, KIT_SAMPLE_TAB_INITIAL_VALUES} from "../../constants";

const useEditKitSamplesTab = ({values = {}}) => {
  const typeForm = TYPE_FORMS.EDIT_KIT_SAMPLES;
  const {t} = useTranslation();

  const allKits = useSelector(selectAllKits);
  const currentUser = useSelector(getCurrentUser);
  const currentKitId = useSelector(selectCurrentKitId);
  const savedEditSampleTabData = useSelector(state => state.samples.modalData[typeForm]);
  const allSamples = useSelector(selectAllSamples);
  const generalCurrentSampleId = useSelector(selectCurrentSampleId);
  const savedCurrentSampleId = values.currentSampleId;
  const currentSampleId = savedCurrentSampleId || generalCurrentSampleId;
  const currentSample = allSamples?.find(sample => sample.sampleId === currentSampleId) ?? null;
  const sampleImgs = currentSample?.images ?? [];

  const currentKit = allKits?.find(kit => kit.kitId === currentKitId);
  const kitImages = currentKit?.images ?? [];

  const validationSchema = Yup.object().shape({
    kitSku: Yup.string(),
    setDescArea: Yup.string().required(t("enter name")),

    factoryId: Yup.number(t("Оберіть фабрику зі списку")).required(t("Оберіть фабрику зі списку")).nullable(),
    groupId: Yup.number().required(t("select gr")).nullable(),
    materialId: Yup.number().required(t("select mat")).nullable(),
    name: Yup.string().required(t("enter name")),
  });

  const initialValues = {
    ...KIT_SAMPLE_TAB_INITIAL_VALUES,
    kitSku: currentKit?.skuNumber ?? "",
    setDescArea: currentKit?.name ?? "",
    ...formSampleValues(currentSample),
    ...savedEditSampleTabData,
    brandManager: `${currentUser?.lastName ?? ""} ${currentUser?.firstName ?? ""}`,
  };

  return {typeForm, validationSchema, initialValues, kitImages, currentSample, sampleImgs, currentKit};
};

export default useEditKitSamplesTab;
